import { Dialog, Box } from '@chakra-ui/react';
import { XIcon } from '@phosphor-icons/react';

interface DemoVideoDialogProps {
  open: boolean;
  onClose: () => void;
}

const YOUTUBE_VIDEO_ID = 'h2EHHHPlZRk';

const DemoVideoDialog = ({ open, onClose }: DemoVideoDialogProps) => {
  const handleOpenChange = (details: { open: boolean }) => {
    if (!details.open) {
      onClose();
    }
  };

  return (
    <Dialog.Root open={open} onOpenChange={handleOpenChange} size="xl" placement="center">
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content
          maxW={{ base: '95vw', sm: '400px' }}
          borderRadius="30px"
          position="relative"
          p={0}
          overflow="hidden"
          bg="black"
        >
          <Dialog.CloseTrigger
            aria-label="Close dialog"
            position="absolute"
            top="16px"
            right="16px"
            zIndex={100}
            bg="blackAlpha.500"
            border="none"
            cursor="pointer"
            borderRadius="full"
            p="8px"
            _hover={{
              bg: 'blackAlpha.700'
            }}
          >
            <XIcon size={24} weight="bold" color="white" />
          </Dialog.CloseTrigger>

          <Box position="relative" w="100%" style={{ aspectRatio: '9 / 16' }}>
            {open && (
              <iframe
                src={`https://www.youtube.com/embed/${YOUTUBE_VIDEO_ID}?autoplay=1&rel=0`}
                title="Travo Demo Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{
                  position: 'absolute',
                  inset: 0,
                  width: '100%',
                  height: '100%',
                  border: 'none',
                  borderRadius: '30px'
                }}
              />
            )}
          </Box>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
};

export default DemoVideoDialog;
